import type { UserDoc } from './types';

export interface ProfileChecklist {
  label: string;
  done: boolean;
}

export function computeProfileProgress(u: UserDoc | null): {
  pct: number;
  items: ProfileChecklist[];
} {
  const items: ProfileChecklist[] = [];
  const p = u?.personal ?? {};
  const pi = u?.pilot ?? {};
  const ec = p.emergencyContact ?? { name: '', relationship: '', phone: '' };
  const d = u?.disclosures ?? {};
  const ins = u?.insurance ?? {};

  items.push({
    label: 'Personal info',
    done: Boolean(p.firstName && p.lastName && p.dateOfBirth && p.address && p.phone),
  });
  items.push({
    label: 'Emergency contact',
    done: Boolean(ec.name && ec.relationship && ec.phone),
  });
  items.push({
    label: 'Pilot certificate',
    done: Boolean(pi.certificateType && pi.certificateNumber && pi.certificateIssueDate),
  });
  items.push({
    label: 'Hours summary',
    done:
      Number.isFinite(pi.totalHours) &&
      Number.isFinite(pi.hoursIn172) &&
      Number.isFinite(pi.hoursLast90) &&
      Number.isFinite(pi.hoursLast12Months),
  });
  items.push({
    label: 'Medical certificate',
    done: Boolean(pi.medicalClass && pi.medicalIssueDate && pi.medicalExpiration),
  });
  items.push({
    label: 'Flight review',
    done: Boolean(pi.lastBFR && pi.bfrExpiration),
  });
  items.push({
    label: 'Renter’s insurance',
    done: Boolean(ins.carrier && ins.policyNumber && ins.liabilityLimit && ins.expirationDate),
  });
  items.push({
    label: 'Background disclosures',
    done: ['priorAccident', 'priorEnforcement', 'priorInsuranceRefusal', 'dui', 'pendingActions']
      .every((k) => Boolean((d as Record<string, { answer?: string }>)[k]?.answer)),
  });

  const done = items.filter((i) => i.done).length;
  const pct = items.length ? Math.round((done / items.length) * 100) : 0;
  return { pct, items };
}
